const USER_PREF_PRESETS_CLIENT_CUSTOM = {
    vehicleSortType: "electric_range",
};

export default USER_PREF_PRESETS_CLIENT_CUSTOM;